import { HStack, Popover, Tag, Text, Whisper } from "rsuite";
import "./renderTags.scss";

const RenderTags = ({ labelKey = "label", valueKey = "value" } = {}) => {
  const renderFunction = (values, items, tags) => {
    if (!values || values.length === 0) {
      return null;
    }

    const [firstTag] = tags;
    if (values.length === 1) {
      return firstTag;
    }

    const speaker = (
      <Popover>
        <ul>
          {items.slice(1).map((item) => (
            <li key={item?.[valueKey] || item?.[labelKey]}>
              <HStack>
                <Text className="popover-content">{item?.[labelKey]}</Text>
              </HStack>
            </li>
          ))}
        </ul>
      </Popover>
    );

    return (
      <>
        {firstTag}
        <Whisper placement="top" trigger="hover" speaker={speaker}>
          <strong>
            <Tag>+{values.length - 1}</Tag>
          </strong>
        </Whisper>
      </>
    );
  };

  renderFunction.displayName = "RenderTags";
  return renderFunction;
};

export default RenderTags;
